import lazyLoad from "common/utils/lazyLoad";

// dynamically imported pillar component
export default lazyLoad(
  () => import(/* webpackChunkName: "GpContactsPillar" */ "."),
  null,
  //   <Flex justifyContent="center" alignItems="center">
  //     <LoadingIndicator variant="primary" />
  //   </Flex>,
);
